import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import {
  CmpSelectField,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import {
  common_brandbasedgroup_GETROW,
  common_brandgroup_GETROW,
  common_groupstructure_GETROW,
  common_VendorListReport_GETROW,
  ISTCRA_ISTCRB_Update,
} from "../../Server/ApiV2";
import axios from "axios";
import { getGlobals } from "../../Configs";
import GCAutocompleteCheckboxFixSize from "../../Component/Common/ReuseableComponent/GCAutocompleteCheckboxFixSize";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import moment from "moment";
import { StockSetupChangeRequestRo, vRdxUserInfo } from "../../Redux/roStore";
import { useDispatch, useSelector } from "react-redux";
import { Head_Set } from "./SliceStockSetupChangeRequest";
import "./StockSetupChangeRequest.css";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import ItemSearchModal from "./ItemSearchModal";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import GCBrandSearch from "../../Component/Common/ReuseableComponent/GCBrandSearch";
import GCSupplierSearch from "../../Component/Common/ReuseableComponent/GCSupplierSearch";
import GCToggleSearchV1 from "../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import { fExecuteAPI } from "../../Server/Apis";
import UndoIcon from "@mui/icons-material/Undo"; 
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { confirmAlert } from "react-confirm-alert";


const FilterModal = ({
  vMediaQuery,
  xMediaQuery,
  fLoadDetail,
  handleClose,
}) => {
  const baseURL = getGlobals().API_BASE_URL;
  const apiRef = useGridApiRef();

  const dispatch = useDispatch();

  const HeadObjectInit = {
    sMainGroup: "All",
    sSubGroup: "All",
    sCategory: "All",
    sMainSupplier: "All",
    sBrand: "All",
    sLocationArr: [],
    sLocationPrnt: "",
    sLocationCode: "",
    sLocationName: "",
    sMainGroupArr: [],
    sMainGroupPrnt: "",
    sMainGroupCode: "",
    sMainGroupName: "",
    sSubGroupArr: [],
    sSubGroupPrnt: "",
    sSubGroupCode: "",
    sSubGroupName: "",
    sCategoryArr: [],
    sCategoryPrnt: "",
    sCategoryCode: "",
    sCategoryName: "",
    sMainSupplierArr: [],
    sMainSupplierPrnt: "",
    sMainSupplierCode: "",
    sMainSupplierName: "",
    sBrandArr: [],
    sBrandPrnt: "",
    sBrandCode: "",
    sBrandName: "",
    sBrandCategoryArr: [],
    sBrandCategoryPrnt: "",
    sBrandCategoryCode: "",
    sBrandCategoryName: "",
    dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    dateTo: new Date(),
    dcItemOnly: "B",
    deleteInsert: "N",
    sSupplierSearchValue: "",
    sBrandSearchValue: "",
  };

  const yesNoOptions = [
    { Uid: "Y", Name: "Yes" },
    { Uid: "N", Name: "No" },
  ];

  const activeOptions = [
    { Uid: "Y", Name: "Active" },
    { Uid: "N", Name: "Inactive" },
  ];

  const allowedOptions = [
    { Uid: "Y", Name: "Allowed" },
    { Uid: "N", Name: "Not Allowed" },
  ];
  const sWebStockReportData = [
    { Uid: "All", Value: "ALL" },
    { Uid: "Is", Value: "Is" },
  ];
  let initError = {
    itemCode: "",
    itemName: "",
  };
  let detailInitObj = {
    itemCode: "",
    itemName: "",
  };
  const ynFieldList = [
    "New_DisContinued",
    "New_ItActive",
    "New_DCDisCon",
    "New_CNTRLPUR",
    "New_LCLPur",
  ];
  // use state start here
  const [sMainGroupData, setMainGroupData] = useState([]);
  const [sCategoryData, setCategoryData] = useState([]);
  const [sSubGroupData, setSubGroupData] = useState([]);
  const [sMainSupplierData, setMainSupplierData] = useState([]);
  const [sBrandData, setBrandData] = useState([]);
  const [sBrandCategoryData, setBrandCategoryData] = useState([]);
  const [row, setRow] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const [masterData, setMasterData] = useState(HeadObjectInit);
  const [searchModal, setSearchModal] = useState(false);
  const [detailObj, setDetailObj] = useState(detailInitObj);
  const [errors, setErrors] = useState(initError);
  const [bulkYN, setBulkYN] = useState(
    ynFieldList.reduce((acc, f) => ({ ...acc, [f]: "" }), {})
  );
  const [originalRows, setOriginalRows] = useState([]);

  const [bulkQty, setBulkQty] = useState({
    minShelfQty: "",
    maxShelfQty: "",
    minStockDays: "",
    maxStockDays: "",
    safetyStockDays: "",
  });

  //use selectors
  const transObj = useSelector(
    (state) => state.SliceStockSetupChangeRequest.value.Head
  );
  const vRdxKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const isHidingColumn = vRdxKernObj?.STOCK_SETUP_MAX_FIELD?.Val === "N";

  const columns = [
          {
  field: "checked",
  headerName: "",
  width: 50,
  sortable: false,
  filterable: false,

  renderCell: (params) => (
    <Checkbox
      checked={params.row.checked || false}
      onChange={(e) => {
        const checked = e.target.checked;

        setRow((prev) =>
          prev.map((r) => {
            if (r.Id !== params.row.Id) return r;

            return {
              ...r,
              checked,
              New_DisContinued: checked
                ? "Y"
                : r[BASE_FLAGS.New_DisContinued] ?? "N",
            };
          })
        );
      }}
    />
  ),
},
    {
      field: "serialNo",
      headerName: "S.No",
      width: 70,
      sortable: false,
      filterable: false,
      valueGetter: (params) => `${params.api.getRowIndex(params.id) + 1}`,
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 80,
    },
    {
      field: "ItemName",
      headerName: "Item Name",
      width: 300,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            lineHeight: "1.4em",
          }}
        >
          {params.value}
        </div>
      ),
    },

    {
      headerName: "Last Purchase Date",
      field: "LPDate",
      width: 120,
      align: "center",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      headerName: "Created Date ",
      field: "CreatedDate",
      width: 90,
      align: "center",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Old_DisContinued",
      headerName: "Old",
      align: "center",
      width: 40,
      cellClassName: (params) =>
        params.row.Old_DisContinued !== params.row.New_DisContinued
          ? "cell-new"
          : "",
    },
    {
      field: "New_DisContinued",
      headerName: "New",
      align: "center",
      width: 60,
      cellClassName: (params) =>
        params.row.Old_DisContinued !== params.row.New_DisContinued
          ? "highlight-cell"
          : "",
      renderCell: (params) => (
        <Select
          value={params.value || ""}
          onChange={(e) =>
            handleFieldEdit(params, e.target.value, "New_DisContinued")
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (row) => row.ItmCd === params.row.ItmCd
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="New_DisContinued-${nextRow.ItmCd}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          displayEmpty
          inputProps={{
            name: `New_DisContinued-${params.row.ItmCd}`,
          }}
          fullWidth
        >
          {yesNoOptions.map((opt) => (
            <MenuItem key={opt.Uid} value={opt.Uid}>
              {opt.Uid}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      field: "Old_ItActive",
      headerName: "Old",
      align: "center",
      width: 40,
      cellClassName: (params) =>
        params.row.Old_ItActive !== params.row.New_ItActive ? "cell-new" : "",
    },
    {
      field: "New_ItActive",
      headerName: "New",
      align: "center",
      width: 60,
      cellClassName: (params) =>
        params.row.Old_ItActive !== params.row.New_ItActive
          ? "highlight-cell"
          : "",
      renderCell: (params) => (
        <Select
          value={params.value || ""}
          onChange={(e) =>
            handleFieldEdit(params, e.target.value, "New_ItActive")
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (row) => row.ItmCd === params.row.ItmCd
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="New_ItActive-${nextRow.ItmCd}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          displayEmpty
          inputProps={{
            name: `New_ItActive-${params.row.ItmCd}`,
          }}
          fullWidth
        >
          {activeOptions.map((opt) => (
            <MenuItem key={opt.Uid} value={opt.Uid}>
              {opt.Uid}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      field: "Old_ShelfQty2",
      headerName: "Old",
      align: "center",
      width: 40,
      cellClassName: (params) =>
        params.row.Old_ShelfQty2 !== params.row.New_ShelfQty2 ? "cell-new" : "",
    },
    {
      field: "New_ShelfQty2",
      headerName: "New",
      align: "center",
      width: 56,
      cellClassName: (params) =>
        params.row.Old_ShelfQty2 !== params.row.New_ShelfQty2
          ? "highlight-cell"
          : "",
      renderCell: (params) => (
        <TextField
          type="number"
          value={params.value}
          onChange={(e) =>
            handleFieldEdit(params, e.target.value, "New_ShelfQty2", parseInt)
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (row) => row.ItmCd === params.row.ItmCd
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="New_ShelfQty2-${nextRow.ItmCd}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          inputProps={{ name: `New_ShelfQty2-${params.row.ItmCd}` }}
          InputProps={{
            sx: {
              input: {
                textAlign: "center", // ✅ centers the number inside
              },
            },
          }}
        />
      ),
    },
    {
      field: "Old_ShelfQty",
      headerName: "Old",
      align: "center",
      width: 40,
      cellClassName: (params) =>
        params.row.Old_ShelfQty !== params.row.New_ShelfQty ? "cell-new" : "",
    },
    {
      field: "New_ShelfQty",
      headerName: "New",
      align: "center",
      width: 56,
      cellClassName: (params) =>
        params.row.Old_ShelfQty !== params.row.New_ShelfQty ? "highlight-cell" : "",
      renderCell: (params) => (
        <TextField
          type="number"
          value={params.value}
          onChange={(e) =>
            handleFieldEdit(params, e.target.value, "New_ShelfQty", parseInt)
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (row) => row.ItmCd === params.row.ItmCd
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="New_ShelfQty-${nextRow.ItmCd}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          inputProps={{ name: `New_ShelfQty-${params.row.ItmCd}` }}
          InputProps={{
            sx: {
              input: {
                textAlign: "center", // ✅ centers the number inside
              },
            },
          }}
        />
      ),
    },
    {
      hide: isHidingColumn,
      field: "Old_DCDisCon",
      headerName: "Old",
      align: "center",
      width: 50,
      cellClassName: (params) =>
        params.row.Old_DCDisCon !== params.row.New_DCDisCon
          ? "cell-new"
          : "",
    },
    {
      hide: isHidingColumn,
      field: "New_DCDisCon",
      headerName: "New",
      align: "center",
      width: 70,
      cellClassName: (params) =>
        params.row.Old_DCDisCon !== params.row.New_DCDisCon
          ? "highlight-cell"
          : "",
      renderCell: (params) => (
        <Select
          value={params.value || ""}
          onChange={(e) =>
            handleFieldEdit(params, e.target.value, "New_DCDisCon")
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (row) => row.ItmCd === params.row.ItmCd
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="New_DCDisCon-${nextRow.ItmCd}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          displayEmpty
          inputProps={{
            name: `New_DCDisCon-${params.row.ItmCd}`,
          }}
          fullWidth
        >
          {yesNoOptions.map((opt) => (
            <MenuItem key={opt.Uid} value={opt.Uid}>
              {opt.Uid}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      hide: isHidingColumn,
      field: "Old_CNTRLPUR",
      headerName: "Old",
      align: "center",
      width: 50,
      cellClassName: (params) =>
        params.row.Old_CNTRLPUR !== params.row.New_CNTRLPUR ? "cell-new" : "",
    },
    {
      hide: isHidingColumn,
      field: "New_CNTRLPUR",
      headerName: "New",
      align: "center",
      width: 70,
      cellClassName: (params) =>
        params.row.Old_CNTRLPUR !== params.row.New_CNTRLPUR ? "highlight-cell" : "",
      renderCell: (params) => (
        <Select
          value={params.value || ""}
          onChange={(e) =>
            handleFieldEdit(params, e.target.value, "New_CNTRLPUR")
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (row) => row.ItmCd === params.row.ItmCd
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="New_CNTRLPUR-${nextRow.ItmCd}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          displayEmpty
          inputProps={{
            name: `New_CNTRLPUR-${params.row.ItmCd}`,
          }}
          fullWidth
        >
          {yesNoOptions.map((opt) => (
            <MenuItem key={opt.Uid} value={opt.Uid}>
              {opt.Uid}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      hide: isHidingColumn,
      field: "Old_LCLPur",
      headerName: "Old",
      align: "center",
      width: 40,
      cellClassName: (params) =>
        params.row.Old_LCLPur !== params.row.New_LCLPur ? "cell-new" : "",
    },
    {
      hide: isHidingColumn,
      field: "New_LCLPur",
      headerName: "New",
      align: "center",
      width: 60,
      cellClassName: (params) =>
        params.row.Old_LCLPur !== params.row.New_LCLPur ? "highlight-cell" : "",
      renderCell: (params) => (
        <Select
          value={params.value || ""}
          onChange={(e) =>
            handleFieldEdit(params, e.target.value, "New_LCLPur")
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (row) => row.ItmCd === params.row.ItmCd
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="New_LCLPur-${nextRow.ItmCd}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          displayEmpty
          inputProps={{
            name: `New_LCLPur-${params.row.ItmCd}`,
          }}
          fullWidth
        >
          {allowedOptions.map((opt) => (
            <MenuItem key={opt.Uid} value={opt.Uid}>
              {opt.Uid}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      hide: isHidingColumn,
      field: "Old_MinStockDays",
      headerName: "Old",
      align: "center",
      width: 40,
      cellClassName: (params) =>
        params.row.Old_MinStockDays !== params.row.New_MinStockDays
          ? "cell-new"
          : "",
    },
    {
      hide: isHidingColumn,
      field: "New_MinStockDays",
      headerName: "New",
      align: "center",
      width: 56,
      type: "number",
      cellClassName: (params) =>
        params.row.Old_MinStockDays !== params.row.New_MinStockDays
          ? "highlight-cell"
          : "",
      renderCell: (params) => (
        <TextField
          type="number"
          value={params.value}
          onChange={(e) =>
            handleFieldEdit(
              params,
              e.target.value,
              "New_MinStockDays",
              parseInt
            )
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (row) => row.ItmCd === params.row.ItmCd
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="New_MinStockDays-${nextRow.ItmCd}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          inputProps={{ name: `New_MinStockDays-${params.row.ItmCd}` }}
          InputProps={{
            sx: {
              input: {
                textAlign: "center", // ✅ centers the number inside
              },
            },
          }}
        />
      ),
    },
    {
      hide: isHidingColumn,
      field: "Old_MaxStockDays",
      headerName: "Old",
      align: "center",
      width: 40,
      type: "number",
      cellClassName: (params) =>
        params.row.Old_MaxStockDays !== params.row.New_MaxStockDays
          ? "cell-new"
          : "",
    },
    {
      hide: isHidingColumn,
      field: "New_MaxStockDays",
      headerName: "New",
      width: 56,
      align: "center",
      type: "number",
      cellClassName: (params) =>
        params.row.Old_MaxStockDays !== params.row.New_MaxStockDays
          ? "highlight-max"
          : "",
    },

    {
      hide: isHidingColumn,
      field: "Old_SafetyStockDays",
      headerName: "Old",
      align: "center",
      width: 50,
      cellClassName: (params) =>
        params.row.Old_SafetyStockDays !== params.row.New_SafetyStockDays
          ? "cell-new"
          : "",
    },
    {
      hide: isHidingColumn,
      field: "New_SafetyStockDays",
      headerName: "New",
      align: "center",
      width: 70,
      type: "number",
      cellClassName: (params) =>
        params.row.Old_SafetyStockDays !== params.row.New_SafetyStockDays
          ? "highlight-cell"
          : "",
      renderCell: (params) => (
        <TextField
          type="number"
          value={params.value}
          onChange={(e) =>
            handleFieldEdit(
              params,
              e.target.value,
              "New_SafetyStockDays",
              parseInt
            )
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              const currentRowIndex = row.findIndex(
                (row) => row.ItmCd === params.row.ItmCd
              );
              const nextRow = row[currentRowIndex + 1];
              if (nextRow) {
                const nextInput = document.querySelector(
                  `input[name="New_SafetyStockDays-${nextRow.ItmCd}"]`
                );
                if (nextInput) nextInput.focus();
              }
            }
          }}
          inputProps={{
            name: `New_SafetyStockDays-${params.row.ItmCd}`,
          }}
          InputProps={{
            sx: {
              input: {
                textAlign: "center", // ✅ centers the number inside
              },
            },
          }}
        />
      ),
    },
    {
      hide: isHidingColumn,
      field: "Barcode",
      headerName: "Barcode",
      width: xMediaQuery ? 150 : 115,
      align: "center",
      type: "number",
    },
    {
      field: "MainGroupName",
      headerName: "Main Group Name",
      align: "left",
      width: xMediaQuery ? 250 : 200,
    },
    {
      field: "SubGroupName",
      headerName: "Sub Group Name",
      align: "left",
      width: xMediaQuery ? 200 : 170,
    },
    {
      field: "CategoryName",
      headerName: "Category Name",
      align: "left",
      width: xMediaQuery ? 200 : 170,
    },
    {
      field: "Vendor",
      headerName: "Vendor",
      align: "left",
      width: xMediaQuery ? 250 : 200,
    },
    {
      field: "Brand",
      headerName: "Brand",
      align: "left",
      width: xMediaQuery ? 160 : 120,
    },
    {
      hide: isHidingColumn,
      field: "SalesQty",
      headerName: "Sales Qty",
      width: xMediaQuery ? 50 : 50,
      align: "center",
      type: "number",
    },

    {
      hide: isHidingColumn,
      field: "StockQty",
      headerName: "Stock Qty",
      width: xMediaQuery ? 50 : 50,
      align: "center",
      type: "number",
    },
    {
      hide: isHidingColumn,
      field: "CONSM",
      headerName: "CONSM",
      align: "center",
      width: xMediaQuery ? 60 : 60,
    },
  ];

  const columnGroupingModel = [
    {
      groupId: "Discontinued",
      headerName: "Discontinued",
      children: [{ field: "Old_DisContinued" }, { field: "New_DisContinued" }],
    },
    {
      groupId: "Active",
      headerName: "Active",
      children: [{ field: "Old_ItActive" }, { field: "New_ItActive" }],
    },
    {
      groupId: "Old_DCDisCon",
      headerName: "DC Discontinued",
      children: [{ field: "Old_DCDisCon" }, { field: "New_DCDisCon" }],
    },
    {
      groupId: "CentralPurchase",
      headerName: "Central Purchase",
      children: [{ field: "Old_CNTRLPUR" }, { field: "New_CNTRLPUR" }],
    },
    {
      groupId: "LocalPurchase",
      headerName: "Local Purchase",
      children: [{ field: "Old_LCLPur" }, { field: "New_LCLPur" }],
    },
    {
      groupId: "Old_MinStockDays",
      headerName: "Min.Stock Days",
      children: [{ field: "Old_MinStockDays" }, { field: "New_MinStockDays" }],
    },
    {
      groupId: "Old_SafetyStockDays",
      headerName: "Safety StockDays",
      children: [
        { field: "Old_SafetyStockDays" },
        { field: "New_SafetyStockDays" },
      ],
    },
    {
      groupId: "Old_MaxStockDays",
      headerName: "Max.Stock Days",
      children: [{ field: "Old_MaxStockDays" }, { field: "New_MaxStockDays" }],
    },
    {
      groupId: "Old_ShelfQty",
      headerName: "Max.Shelf Qty",
      children: [{ field: "Old_ShelfQty" }, { field: "New_ShelfQty" }],
    },
    {
      groupId: "Old_ShelfQty2",
      headerName: "Min.Shelf Qty",
      children: [{ field: "Old_ShelfQty2" }, { field: "New_ShelfQty2" }],
    },
  ];

  //use effect start here
  useEffect(() => {
    if (masterData.sBrandArr.length > 0) {
      fetchBrandCategory();
    }
  }, [masterData.sBrandArr]);

  useEffect(() => {
    setMasterData((prev) => ({
      ...prev,
      sSubGroup: "All",
      sSubGroupArr: [],
    }));
  }, [masterData.sMainGroupArr]);

  useEffect(() => {
    setMasterData((prev) => ({
      ...prev,
      sCategory: "All",
      sCategoryArr: [],
    }));
  }, [masterData.sSubGroupArr]);
  useEffect(() => {
    const handleClick = (event) => {
      // For item name toggle
      if (sItemToggleDropdown) {
        const itemToggleElement = event.target.closest(".toggleSearch");
        if (!itemToggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);
  //use effect end here

  //API call start here
  const fWmsStockRepotArr = async (xGroupStructureObj, setGroupData) => {
    let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
    const CurrentMaingroupArr = await common_groupstructure_GETROW(FinalObj);
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fMainGroup = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      sMainGroup: e.target.value,
      sMainGroupArr: [],
      sMainGroupPrnt: "",
      sMainGroupName: "",
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);

    if (e.target.value.toUpperCase() == "ALL") {
      setMainGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj = {
        Prnt: "",
        Lvl: "1",
      };
      await fWmsStockRepotArr(xGroupStructureObj, setMainGroupData);
    }
  };

  const fSubGroup = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    setCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setSubGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      const mainGrpData = masterData?.sMainGroupArr
        .map((item) => `${item}`)
        .join(",");
      let xGroupStructureObj2 = {
        Prnt: mainGrpData,
        Lvl: "2",
      };
      await fWmsStockRepotArr(xGroupStructureObj2, setSubGroupData);
    }
  };

  const fCategory = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    if (e.target.value.toUpperCase() == "ALL") {
      setCategoryData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      const subGrpData = masterData?.sSubGroupArr
        .map((item) => `${item}`)
        .join(",");
      let xGroupStructureObj2 = {
        Prnt: subGrpData,
        Lvl: "3",
      };

      await fWmsStockRepotArr(xGroupStructureObj2, setCategoryData);
    }
  };

  const GetWmsStockRepotMainSupplier = async (setGroupData) => {
    const CurrentMaingroupArr = await common_VendorListReport_GETROW("");
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fMainSupplier = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sMainSupplierArr: [],
      sMainSupplierPrnt: "",
      sMainSupplierName: "",
    }));
    if (e.target.value.toUpperCase() == "ALL") {
      setMainSupplierData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotMainSupplier(setMainSupplierData);
    }
  };

  const GetWmsStockRepotBrand = async (setGroupData) => {
    const CurrentMaingroupArr = await common_brandgroup_GETROW("");
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const fBrand = async (e) => {
    setMasterData((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sBrandArr: [],
      sBrandPrnt: "",
      sBrandName: "",
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
    setBrandCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setBrandData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotBrand(setBrandData);
    }
  };

  const fWmsStockRepotBrandArr = async (xGroupStructureObj, setGroupData) => {
    let FinalObj = fcheck_null_undefine_replace_empty(xGroupStructureObj);
    const CurrentMaingroupArr = await common_brandbasedgroup_GETROW(FinalObj);
    if (CurrentMaingroupArr?.status === 200) {
      setGroupData(CurrentMaingroupArr?.data?.ResultSet);
    }
  };

  const getCyclicCountItemGetRow = async () => {
    const HeadObject = StockSetupChangeRequestRo();

    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    const mainGrpData = masterData?.sMainGroupArr
      .map((item) => `${item}`)
      .join(",");
    const subGrpData = masterData?.sSubGroupArr
      .map((item) => `${item}`)
      .join(",");
    const catGrpData = masterData?.sCategoryArr
      .map((item) => `${item}`)
      .join(",");
    // const suplGrpData = masterData?.sMainSupplierArr
    //   .map((item) => `${item}`)
    //   .join(",");
    const suplGrpData = masterData?.sMainSupplierArr
      .map((x) => x.AcCd)
      .join(", ");
    const brandGrpData = masterData?.sBrandArr.map((x) => x.UID).join(", ");

    if (HeadObject?.Head?.A_Location === "") {
      fAlertToast("INFO", "Location should not be empty");
      return;
    }

    if (masterData?.dateFrom === "") {
      fAlertToast("INFO", "From Date should not be empty");
      return;
    }

    if (masterData?.dateTo === "") {
      fAlertToast("INFO", "To Date should not be empty");
      return;
    }

    if (HeadObject?.Head?.VendorCd === "") {
      fAlertToast("INFO", "Vendor should not be empty");
      return;
    }

    try {
      const response = await axios.post(
        `${baseURL}Master/ISTCR_Items_Master_GetRow`,
        fcheck_null_undefine_replace_empty({
          v_MainGrp: mainGrpData,
          v_SubGrp: subGrpData,
          v_Grp: catGrpData,
          v_BrandCd: brandGrpData,
          v_Supplier: suplGrpData,
          v_Loc: HeadObject?.Head?.A_Location,
          v_Date1: moment(masterData?.dateFrom).format("MM/DD/YYYY"),
          v_Date2: moment(masterData?.dateTo).format("MM/DD/YYYY"),
          v_DCItemsOnly: masterData?.dcItemOnly,
          v_ItmCd: "",
        })
      );
      if (response?.status === 200) {
        loader.style.display = "none";
        setRow(response?.data?.ResultSet);
        setOriginalRows(response?.data?.ResultSet);
      }
    } catch (error) {
      loader.style.display = "none";
      fAlertToast("FAILED", error?.response?.data?.message || error?.message);
    }
  };

  const HeadObject = StockSetupChangeRequestRo();

  const fSave = async () => {
    if (selectedRows?.length == 0) {
      fAlertToast("FAILED", "select atleast one line item");
      return;
    }
    const vRdxUserInfoObj = vRdxUserInfo();

    if (HeadObject?.Head?.A_Transid === "") {
      fAlertToast("INFO", "Transaction id should not be empty");
      return;
    }

    if (transObj.VendorName == "") {
      fAlertToast("INFO", "Vendor should not be empty");
      return;
    }

    if (transObj.VendorCd == "") {
      fAlertToast("INFO", "Vendor code should not be empty");
      return;
    }

    if (HeadObject?.Head?.A_Date == "") {
      fAlertToast("INFO", "Date should not be empty");
      return;
    }

    if (HeadObject?.Head?.A_Location == "") {
      fAlertToast("INFO", "Location should not be empty");
      return;
    }

    const items = selectedRows?.map((item) => ({
      B_Srno: 0,
      B_Itemcd: item.ItmCd,
      Old_DisContinued: item.Old_DisContinued,
      New_DisContinued: item.New_DisContinued,
      Old_ItActive: item.Old_ItActive,
      New_ItActive: item.New_ItActive,
      Old_DCDisCon: item.Old_DCDisCon,
      New_DCDisCon: item.New_DCDisCon,
      Old_CNTRLPUR: item.Old_CNTRLPUR,
      New_CNTRLPUR: item.New_CNTRLPUR,
      Old_LCLPur: item.Old_LCLPur,
      New_LCLPur: item.New_LCLPur,
      Old_MinStockDays: item.Old_MinStockDays,
      New_MinStockDays: item.New_MinStockDays,
      Old_SafetyStockDays: item.Old_SafetyStockDays,
      New_SafetyStockDays: item.New_SafetyStockDays,
      Old_MaxStockDays: item.Old_MaxStockDays,
      New_MaxStockDays: item.New_MaxStockDays,
      Old_ShelfQty: item.Old_ShelfQty,
      New_ShelfQty: item.New_ShelfQty,
      Old_ShelfQty2: item.Old_ShelfQty2,
      New_ShelfQty2: item.New_ShelfQty2,
    }));

    if (items?.length == 0) {
      fAlertToast("INFO", "LineItem should not be empty");
      return;
    }

    var obj = {
      A_TransId: HeadObject?.Head?.A_Transid,
      A_Date: moment(HeadObject?.Head?.A_Date).format("MM/DD/YYYY"),
      A_Loc: HeadObject?.Head?.A_Location,
      A_Narration: HeadObject?.Head?.A_Narration,
      A_UserCd: vRdxUserInfoObj?.UserID,
      DeleteInsert: masterData?.deleteInsert,
      Items: items,
      isApproved: false,
    };

    // console.log("obj", obj);
    // console.log("HeadObj", HeadObject);

    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const StockResponse = await ISTCRA_ISTCRB_Update(FinalObj);
    if (StockResponse?.status === 200) {
      fAlertToast("SUCCESS", "Saved Successfully");
      fLoadDetail(StockResponse?.data?.ResultSet[0]?.A_Transid);
      dispatch(
        Head_Set({
          ...transObj,
          A_Transid: StockResponse?.data?.ResultSet[0]?.A_Transid,
        })
      );
      setRow([]);
      setSelectedRows([]);
      handleClose();
    }
  };
  // API call end here

  const fetchBrandCategory = async () => {
    const subGrpData = masterData?.sBrandArr.map((item) => `${item}`).join(",");
    let xGroupStructureObj = {
      grp: subGrpData,
    };
    await fWmsStockRepotBrandArr(xGroupStructureObj, setBrandCategoryData);
  };

  const handleFieldEdit = (params, value, fieldName, parser = (v) => v) => {
    const currentRowIndex = row?.findIndex((r) => r.ItmCd === params.row.ItmCd);
    const originalRow = row?.find((r) => r.ItmCd === params.row.ItmCd);

    const updatedRow = {
      ...row[currentRowIndex],
      [fieldName]: parser(value),
    };

    if (
      fieldName === "New_MinStockDays" ||
      fieldName === "New_SafetyStockDays"
    ) {
      const minVal =
        fieldName === "New_MinStockDays"
          ? parser(value)
          : updatedRow.New_MinStockDays;
      const safetyVal =
        fieldName === "New_SafetyStockDays"
          ? parser(value)
          : updatedRow.New_SafetyStockDays;

      const min = isNaN(minVal) ? 0 : minVal;
      const safety = isNaN(safetyVal) ? 0 : safetyVal;

      updatedRow.New_MaxStockDays = min + safety;
    }

    const newRowData = [...row];
    newRowData[currentRowIndex] = updatedRow;
    setRow(newRowData);

    let updatedSelectedRows = [...selectedRows];
    const rowExistsIndex = updatedSelectedRows.findIndex(
      (r) => r.ItmCd === updatedRow.ItmCd
    );

    const fieldsToCompare = [
      "New_DisContinued",
      "New_ItActive",
      "New_DCDisCon",
      "New_MinStockDays",
      "New_SafetyStockDays",
      "New_MaxStockDays",
      "New_ShelfQty",
      "New_ShelfQty2",
      "New_LCLPur",
      "New_CNTRLPUR",
    ];

    const isDifferent = fieldsToCompare.some(
      (field) => updatedRow[field] !== originalRow[field]
    );
    if (isDifferent) {
      if (rowExistsIndex === -1) {
        updatedSelectedRows.push(updatedRow);
      } else {
        updatedSelectedRows[rowExistsIndex] = updatedRow;
      }
    } else {
      if (rowExistsIndex !== -1) {
        updatedSelectedRows.splice(rowExistsIndex, 1);
      }
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleCheckboxChange = (name) => {
    setMasterData((prev) => ({
      ...prev,
      [name]: prev[name] === "Y" ? "N" : "Y",
    }));
  };

  // Item Code Item Name

  const handleDetailChange = (field, value, event = null) => {
    setDetailObj((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  }; //click anywhere to close the toggle

  const handleItemSelection = async (ItmCd, Name1) => {
    setDetailObj((prev) => ({
      ...prev,
      itemCode: ItmCd,
      itemName: Name1,
    }));
    getCyclicCountItemGetRow(ItmCd);
    setSearchModal(false);
  };

  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        detailObj?.itemName,
        transObj?.A_Location
      );
      if (vItemSearchFull.length > 0) {
        handleItemSelection(
          vItemSearchFull[0]?.ItmCd,
          vItemSearchFull[0]?.Name1
        );
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace" && detailObj?.itemCode) {
      setDetailObj((prev) => ({
        ...prev,
        itemCode: "",
        itemName: "",
      }));
    }
  };

  const fGCToggleItemOnRowClick = async (e) => {
    handleItemSelection(e?.row?.ItmCd, e?.row?.Name1);
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        transObj?.A_Location,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fItemToggleClick = () => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: detailObj?.itemName,
    }));

    if (detailObj?.itemName != "") {
      GetSearchItem(
        detailObj?.itemName,
        "Any",
        transObj?.A_Location,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const GetItemFullSearchArr = async (xItemName, xLoc) => {
    let vItemFullSearchDataObj = {
      anyData: xItemName,
      transType: "F",
      report: "Y",
      loc: xLoc,
    };

    const vItemSearchFull = await fExecuteAPI(
      // "ITEM_SEARCHFULL_GETROW",
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );
    //status code "" so Success is checked
    if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearchFull?.ResultSet?.length > 0) {
        return vItemSearchFull.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearchFull?.Type?.response?.data?.message
          ? vItemSearchFull?.Type?.response?.data?.message
          : "Error in vItemSearchFullArr"
      );
      return [];
    }
  };

  const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
    let vSeatchVendor = {
      Data: xData,
      Type: xType,
      Loc: xA_Loc,
      v_Vendor: HeadObject?.Head?.VendorCd || "",
      v_isActiveOnly: false,
    };
    const vItemSearch = await fExecuteAPI(
      "SEARCHITEM001_GETROW",
      vSeatchVendor
    );
    if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
      let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSearchGridData(vItemSearchArr);
    } else {
      fAlertToast(
        "FAILED",
        vItemSearch.response.data.message
          ? vItemSearch.response.data.message
          : "Error in SearchItem"
      );
    }
  };

  ///bulk edit functions

  // bulk-apply Y / N
  const applyBulkYN = (field, value) => {
    setRow((prev) => prev.map((r) => ({ ...r, [field]: value , applyBulkYN})));
  };
  const BASE_FLAGS = {
    New_DisContinued: "Old_DisContinued",
    New_ItActive: "Old_ItActive",
    New_DCDisCon: "Old_DCDisCon",
    New_CNTRLPUR: "Old_CNTRLPUR",
    New_LCLPur: "Old_LCLPur",
  };
  const NUMERIC_COL_MAP = {
    minShelfQty: "New_ShelfQty2",
    maxShelfQty: "New_ShelfQty",
    minStockDays: "New_MinStockDays",
    maxStockDays: "New_MaxStockDays",
    safetyStockDays: "New_SafetyStockDays",
  };
  const DIFF_FIELDS = [
    "New_DisContinued",
    "New_ItActive",
    "New_DCDisCon",
    "New_CNTRLPUR",
    "New_LCLPur",
    "New_ShelfQty2",
    "New_ShelfQty",
    "New_MinStockDays",
    "New_SafetyStockDays",
    "New_MaxStockDays",
  ];
  const isRowDirty = (r, originals) => {
    const orig = originals.find((o) => o.ItmCd === r.ItmCd);
    if (!orig) return false;
    return DIFF_FIELDS.some((f) => r[f] !== orig[f]);
  };
  useEffect(() => {
    if (!originalRows.length) return;
    const dirty = row.filter((r) => isRowDirty(r, originalRows));
    setSelectedRows(dirty);
  }, [row, originalRows]);

  const resetYNField = (field) => {
    setBulkYN((s) => ({ ...s, [field]: "" }));

    const oldField = BASE_FLAGS[field] || field;
    setRow((prev) =>
      prev.map((r) => ({
        ...r,
        [field]: r[oldField] ?? "N",
          checked: false,
      }))
    );
  };
  const applyBulkQty = (key) => {
    const value = Number(bulkQty[key]);
    if (isNaN(value) || bulkQty[key] === "") return; // nothing to do
    const gridField = NUMERIC_COL_MAP[key];

    setRow((prev) =>
      prev.map((r) => {
        const updated = { ...r, [gridField]: value };

        // keep the derived column in sync
        if (
          gridField === "New_MinStockDays" ||
          gridField === "New_SafetyStockDays"
        ) {
          const min =
            gridField === "New_MinStockDays" ? value : updated.New_MinStockDays;
          const safety =
            gridField === "New_SafetyStockDays"
              ? value
              : updated.New_SafetyStockDays;
          updated.New_MaxStockDays = (Number(min) || 0) + (Number(safety) || 0);
        }
        return updated;
      })
    );
  };

  const resetBulkQty = (key) => {
    const gridField = NUMERIC_COL_MAP[key];

    setRow((prev) =>
      prev.map((r) => {
        const pristine = originalRows.find((o) => o.ItmCd === r.ItmCd);
        if (!pristine) return r; // safety net

        const resetRow = { ...r, [gridField]: pristine[gridField] };
        if (
          gridField === "New_MinStockDays" ||
          gridField === "New_SafetyStockDays"
        ) {
          resetRow.New_MaxStockDays = pristine.New_MaxStockDays;
        }
        return resetRow;
      })
    );

    // clear the input box itself
    setBulkQty((s) => ({ ...s, [key]: "" }));
  };

   const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true,
  });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };
  return (
    <Box sx={{ paddingY: 1, paddingX: 0 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={3} sm={4} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Main Group"} />
              </Grid>
              <Grid item xs={2} sm={2} md={1}>
                <CmpSelectField
                  xtabIndex={"03"}
                  xLabelText="sMainGroup"
                  xValue={masterData.sMainGroup}
                  xOnChange={fMainGroup}
                  xName={"sMainGroup"}
                  xData={sWebStockReportData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={""}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={9}>
                <GCAutocompleteCheckboxFixSize
                  options={sMainGroupData}
                  xValue={masterData.sMainGroupArr}
                  xtabIndex={"04"}
                  xDisabled={
                    masterData?.sMainGroup?.toUpperCase() === "ALL"
                      ? true
                      : false
                  }
                  setValue={setMasterData}
                  objName="sMainGroupArr"
                  label=""
                  placeholder="Search Main Group"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={3} sm={4} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Sub Group"} />
              </Grid>
              <Grid item xs={2} sm={2} md={1}>
                <CmpSelectField
                  xtabIndex={"05"}
                  xLabelText="sSubGroup"
                  xValue={masterData.sSubGroup}
                  xOnChange={fSubGroup}
                  xName={"sSubGroup"}
                  xData={sWebStockReportData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={""}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={9}>
                <GCAutocompleteCheckboxFixSize
                  options={sSubGroupData}
                  xValue={masterData.sSubGroupArr}
                  xtabIndex={"06"}
                  xDisabled={
                    masterData?.sSubGroup?.toUpperCase() === "ALL"
                      ? true
                      : false
                  }
                  setValue={setMasterData}
                  objName="sSubGroupArr"
                  label=""
                  placeholder="Search Sub Group"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={3} sm={4} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Category"} />
              </Grid>
              <Grid item xs={2} sm={2} md={1}>
                <CmpSelectField
                  xtabIndex={"07"}
                  xLabelText="sCategory"
                  xValue={masterData.sCategory}
                  xOnChange={fCategory}
                  xName={"sCategory"}
                  xData={sWebStockReportData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={""}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={9}>
                <GCAutocompleteCheckboxFixSize
                  options={sCategoryData}
                  xValue={masterData.sCategoryArr}
                  xtabIndex={"08"}
                  xDisabled={
                    masterData?.sCategory?.toUpperCase() === "ALL"
                      ? true
                      : false
                  }
                  setValue={setMasterData}
                  objName="sCategoryArr"
                  label=""
                  placeholder="Search Category"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={3} sm={4} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Vendor"} />
              </Grid>
              <Grid item xs={2} sm={2} md={1}>
                <CmpSelectField
                  xtabIndex={"09"}
                  xLabelText="sMainSupplier"
                  xValue={masterData.sMainSupplier}
                  xOnChange={fMainSupplier}
                  xName={"sMainSupplier"}
                  xData={sWebStockReportData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={""}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={9}>
                <GCSupplierSearch
                  xValue={masterData.sSupplierSearchValue} //main input value
                  xOnChange={(e) => {
                    setMasterData((obj) => ({
                      ...obj,
                      // sBrandArr: e.target.value,
                      sSupplierSearchValue: e.target.value,
                    })); //main input onchange
                  }}
                  xReadOnly={
                    masterData?.sMainSupplier?.toUpperCase() === "ALL"
                      ? true
                      : false
                  }
                  basketValue={masterData?.sMainSupplierArr} //Search basket array
                  xListValue={masterData?.sMainSupplierArr
                    .map((x) => x.Name1)
                    .join(", ")} // 2nd main input
                  onApply={(selectedObjects) => {
                    console.log("====================================");
                    console.log("selectedObjects", selectedObjects);
                    console.log("====================================");
                    setMasterData((obj) => ({
                      ...obj,
                      sMainSupplierArr: selectedObjects,
                    }));
                    // setBrandBasket(selectedObjects) //array of object
                  }} // <- handle selected names
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={3} sm={4} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Brand"} />
              </Grid>
              <Grid item xs={2} sm={2} md={1}>
                <CmpSelectField
                  xtabIndex={"11"}
                  xLabelText="sBrand"
                  xValue={masterData.sBrand}
                  xOnChange={fBrand}
                  xName={"sBrand"}
                  xData={sWebStockReportData}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={""}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={9}>
                <GCBrandSearch
                  xValue={masterData?.sBrandSearchValue} //main input value
                  xOnChange={(e) => {
                    setMasterData((obj) => ({
                      ...obj,
                      // sBrandArr: e.target.value,
                      sBrandSearchValue: e.target.value,
                    })); //main input onchange
                  }}
                  xReadOnly={
                    masterData?.sBrand?.toUpperCase() === "ALL" ? true : false
                  }
                  basketValue={masterData?.sBrandArr} //Search basket array
                  xListValue={masterData?.sBrandArr
                    .map((x) => x.Name1)
                    .join(", ")} // 2nd main input
                  onApply={(selectedObjects) => {
                    console.log("====================================");
                    console.log("selectedObjects", selectedObjects);
                    console.log("====================================");
                    setMasterData((obj) => ({
                      ...obj,
                      sBrandArr: selectedObjects,
                    }));
                    // setBrandBasket(selectedObjects) //array of object
                  }} // <- handle selected names
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1} mt={1}>
              <Grid item xs={3} sm={4} md={1.5}>
                <CmpTypographyField xcomponent={"span"} xText={"Items"} />
              </Grid>
              <Grid item xs={2} sm={2} md={1.5}>
                <TextField
                  label=""
                  placeholder="Item Code"
                  value={detailObj?.itemCode}
                  onChange={(event) =>
                    handleDetailChange("itemCode", event.target.value, event)
                  }
                  fullWidth
                  error={errors?.itemCode === "" ? false : true}
                  helperText={errors?.itemCode}
                  disabled={true}
                  size="small"
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={6} sm={6} md={9}>
                <GCToggleSearchV1
                  xLabelText="Item Name"
                  xtabIndex={"101"}
                  xName={"B_ItmName"}
                  xType={"text"}
                  xValue={detailObj?.itemName}
                  xReadOnly={false}
                  xOnChange={(event) => {
                    handleDetailChange("itemName", event.target.value);
                  }}
                  xOnKeyUp={fItemSearchKey}
                  xonClickbtn={fItemSearchKey}
                  xrows={sGridSelectRowData}
                  xcolumns={[
                    { field: "id", headerName: "ID", width: 70, hide: true },
                    { field: "ItmCd", headerName: "Code", width: 90 },
                    { field: "Name1", headerName: "Name", flex: 1 },
                    // { field: "NameFL", headerName: "NameFL", width: 90 },
                  ]} //head
                  xRowClick={fGCToggleItemOnRowClick}
                  xRowCellClick={fGCToggleItemOnCellKeyDown}
                  xToggle={sItemToggleDropdown}
                  xData={["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"]}
                  xOnChangeDropdownInput={fOnChangeItem}
                  xDropdownObj={sItemSearchDropdownObj}
                  xOnKeyUpDropdownInput={fOnKeyUpItem}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              spacing={1}
              alignItems={"center"}
              justifyContent={"center"}
              mt={1}
            >
              {/* From Date */}
              <Grid item xs={6} sm={2.5} md={2} marginTop={0.5}>
                {/* <Typography sx={{ textAlign: "start" }}>From Date</Typography> */}
                <CmpDatePickerField001V1
                  xLabelText="From Date"
                  xName={"dateFrom"}
                  xValue={masterData?.dateFrom}
                  xOnChange={(event) => {
                    if (
                      event?.$d == "Invalid Date" ||
                      event?.$d == null ||
                      event?.$d === undefined ||
                      event?.$d === ""
                    ) {
                      setMasterData((obj) => ({
                        ...obj,
                        dateFrom: new Date(
                          new Date().getFullYear(),
                          new Date().getMonth(),
                          1
                        ),
                      }));
                    } else {
                      setMasterData((obj) => ({
                        ...obj,
                        dateFrom: event.$d,
                      }));
                    }
                  }}
                />
              </Grid>
              {/* To Date */}
              <Grid item xs={6} sm={2.5} md={2} marginTop={0.5}>
                {/* <Typography sx={{ textAlign: "start" }}>To Date</Typography> */}
                <CmpDatePickerField001V1
                  xLabelText="To Date"
                  xName={"dateTo"}
                  xValue={masterData?.dateTo}
                  xOnChange={(event) => {
                    if (
                      event?.$d == "Invalid Date" ||
                      event?.$d == null ||
                      event?.$d === undefined ||
                      event?.$d === ""
                    ) {
                      setMasterData((obj) => ({
                        ...obj,
                        dateTo: new Date(),
                      }));
                    } else {
                      setMasterData((obj) => ({
                        ...obj,
                        dateTo: event.$d,
                      }));
                    }
                  }}
                />
              </Grid>
              {/* Checkbox and Buttons */}
              <Grid item xs={12} sm={7} md={8} pt={2} marginTop={0.5}>
                <FormControlLabel
                  sx={{
                    "& .MuiCheckbox-root": {
                      padding: vMediaQuery
                        ? "0px !important"
                        : "7px !important",
                    },
                  }}
                  control={
                    <Checkbox
                      name="dcItemOnly"
                      checked={masterData?.dcItemOnly === "Y"}
                      onChange={() => {
                        handleCheckboxChange("dcItemOnly");
                      }}
                    />
                  }
                  label="DC Items Only"
                />
                <FormControlLabel
                  sx={{
                    "& .MuiCheckbox-root": {
                      padding: vMediaQuery
                        ? "0px !important"
                        : "7px !important",
                    },
                  }}
                  control={
                    <Checkbox
                      name="deleteInsert"
                      checked={masterData?.deleteInsert === "Y"}
                      onChange={() => {
                        handleCheckboxChange("deleteInsert");
                      }}
                    />
                  }
                  label="Delete & Insert"
                />

                <Button
                  variant="contained"
                  size="small"
                  sx={{ marginRight: 1 }}
                  onClick={() => {
                    setRow([]);
                    setSelectedRows([]);
                    getCyclicCountItemGetRow();
                  }}
                >
                  Load
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  sx={{ marginRight: 1 }}
                  onClick={() => {
                    if (selectedRows?.length > 0) {
                      fSave();
                    } else {
                      fAlertToast("FAILED", "Select atleast one row");
                    }
                  }}
                  // disabled={selectedRows?.length === 0}
                >
                  Save
                </Button>
              <Tooltip title="Export CSV">
                <IconButton color="primary" onClick={handleExport} size="small">
                  <DownloadOutlinedIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Print">
                <IconButton color="primary" onClick={handlePrint} size="small">
                  <PrintOutlinedIcon />
                </IconButton>
              </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* ---------- BULK Y/N SECTION ---------- */}
        {/* ——— BULK-EDIT PANEL ——— */}
        <Grid item xs={12} md={5}>
          <Typography
            variant="h6"
            sx={{ textAlign: "center", marginBottom: "5px" }}
          >
            Bulk Edit
          </Typography>

          <Grid container spacing={1}>
            {/* Left Side - Checkboxes */}
            <Grid item xs={12} sm={6}>
              {" "}
              <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
                <Grid item xs={3} />
                <Grid item xs={2}>
                  <Typography variant="body2">check</Typography>
                </Grid>
                {/* <Grid item xs={2}>
                  <Typography variant="body2">uncheck</Typography>
                </Grid> */}
              </Grid>
              <Grid container>
                {[
                  {
                    label: "Discontinued",
                    field: "New_DisContinued",
                    isVisble: true,
                  },
                  { label: "Active", field: "New_ItActive", isVisble: true },
                  {
                    label: "D CDiscontinued",
                    field: "New_DCDisCon",
                    isVisble: !isHidingColumn,
                  },
                  {
                    label: "Central Purchase",
                    field: "New_CNTRLPUR",
                    isVisble: !isHidingColumn,
                  },
                  {
                    label: "LCL Purchase",
                    field: "New_LCLPur",
                    isVisble: !isHidingColumn,
                  },
                ]
                  .filter((item) => item.isVisble)
                  .map(({ label, field }) => (
                    <Grid
                      item
                      xs={12}
                      key={field}
                      display="flex"
                      alignItems="center"
                      justifyContent="start"
                    >
                      {" "}
                      <Typography variant="body2" sx={{ width: "115px" }}>
                        {label}
                      </Typography>
                      <FormControlLabel
                        control={
                          <Box display="flex" alignItems="center" columnGap={1}>
                            {/* ✔ All → apply 'Y' */}
                            <Checkbox
                              size="small"
                              checked={bulkYN[field] === "Y"}
                              disabled={bulkYN[field] === "N"} // ★ changed
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setBulkYN((s) => ({ ...s, [field]: "Y" }));
                                  applyBulkYN(field, "Y");
                                } else {
                                  // user unticked → clear & reset row values
                                  resetYNField(field);
                                }
                              }}
                              title=""
                            />

                            {/* ✖ All → apply 'N' */}
                            {/* <Checkbox
                              size="small"
                              checked={bulkYN[field] === "N"}
                              disabled={bulkYN[field] === "Y"} // ★ changed
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setBulkYN((s) => ({ ...s, [field]: "N" }));
                                  applyBulkYN(field, "N");
                                } else {
                                  resetYNField(field);
                                }
                              }}
                              title=""
                            /> */}
                          </Box>
                        }
                        //  label={label}
                      />
                      <IconButton
                        size="small"
                        onClick={() => {
                          confirmAlert({
                            title: "Reset",
                            message: `Reset changes for ${label}?`,
                            buttons: [
                              {
                                label: "Yes",
                                onClick: () => resetYNField(field),
                              },
                              { label: "No", onClick: () => {} },
                            ],
                          });
                        }}
                      >
                        <UndoIcon fontSize="small" />
                      </IconButton>
                    </Grid>
                  ))}
              </Grid>
            </Grid>
            <Divider />
            {/* Right Side - Numeric Fields */}
            <Grid item xs={12} sm={6}>
              {[
                {
                  label: "Min Shelf Qty",
                  key: "minShelfQty",
                  isVisible: true,
                },
                {
                  label: "Max Shelf Qty",
                  key: "maxShelfQty",
                  isVisible: true,
                },
                {
                  label: "Min Stock Days",
                  key: "minStockDays",
                  isVisible: !isHidingColumn,
                },
                {
                  label: "Max Stock Days",
                  key: "maxStockDays",
                  isVisible: !isHidingColumn,
                },
                {
                  label: "Safety Stock Days",
                  key: "safetyStockDays",
                  isVisible: !isHidingColumn,
                },
              ]
                .filter((item) => item.isVisible)
                .map(({ label, key }) => (
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    key={key}
                    sx={{ mb: 0.5 }}
                  >
                    <Grid item xs={12} sm={5}>
                      <TextField
                        label={label}
                        size="small"
                        type="number"
                        fullWidth
                        value={bulkQty[key] || ""}
                        inputProps={{
                          maxLength: 4,
                          style: { width: "4ch", textAlign: "right" },
                        }}
                        onChange={(e) =>
                          setBulkQty((s) => ({ ...s, [key]: e.target.value }))
                        }
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ minWidth: 60, mr: 1 }}
                        onClick={() => {
                          confirmAlert({
                            title: "Reset",
                            message: `Are you sure you want to apply this  changes for ${label}?`,
                            buttons: [
                              {
                                label: "Yes",
                                onClick: () => applyBulkQty(key),
                              },
                              { label: "No", onClick: () => {} },
                            ],
                          });
                        }}
                      >
                        APPLY
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        color="error"
                        sx={{ minWidth: 60 }}
                        onClick={() => {
                          confirmAlert({
                            title: "Reset",
                            message: `Are you sure you want to Reset changes for ${label}?`,
                            buttons: [
                              {
                                label: "Yes",
                                onClick: () => resetBulkQty(key),
                              },
                              { label: "No", onClick: () => {} },
                            ],
                          });
                        }}
                      >
                        RESET
                      </Button>
                    </Grid>
                  </Grid>
                ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: 2,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          height: {xs:"30vh",md:"44vh"},
          width: "100%",
        }}
      >
        <DataGridPro
          rowHeight={30}
          headerHeight={40}
          apiRef={apiRef}
          // components={{
          //   Toolbar: CustomToolbar,
          // }}
          rows={row ?? []}
          getRowId={(v) => v.ItmCd}
          columns={columns}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{ columnGrouping: true }}
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
            "& .MuiDataGrid-cell": {
              padding: "0px 2px",
            },
            "& .MuiDataGrid-columnHeader": {
              whiteSpace: "normal",
              lineHeight: "1.2em",
              paddingTop: "8px",
              paddingBottom: "1px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              wordWrap: "break-word",
              fontSize: "11px", // Optional for better fit
            },
            "& .MuiDataGrid-columnHeaderTitleContainer": {
              textAlign: "center",
              justifyContent: "center",
            },
          }}
          hideFooter={true}
          selectionModel={selectedRows.map((row) => row.ItmCd)}
        />
      </Box>
      <CycleCustomModal
        open={searchModal}
        onClose={() => setSearchModal(false)}
        vMediaQuery={vMediaQuery}
        xMediaQuery={xMediaQuery}
        title="Item Search"
      >
        <ItemSearchModal
          open={searchModal}
          xMediaQuery={xMediaQuery}
          handleClose={() => setSearchModal(false)}
          handleRowClick={(item) => {
            setDetailObj((prev) => ({
              ...prev,
              itemCode: item.ItmCd,
              itemName: item.Name1,
            }));
            setErrors(initError);
            setSearchModal(false);
          }}
          location={HeadObject?.Head?.A_Location}
          anyDataItemName={detailObj?.itemName}
        />
      </CycleCustomModal>
    </Box>
  );
};

export default FilterModal;
